import cn from 'classnames';

/**
 * LabelTag 组件 Props
 */
interface LabelTagProps {
  /** 显示的文本内容 */
  text: string;
  /** 自定义类名 */
  className?: string;
  onClick?: () => void;
}

/**
 * LabelTag 标签组件
 * 左侧带绿色竖线装饰，右侧展示文本内容
 */
export const LabelTag: React.FC<LabelTagProps> = props => {
  const { text, className, onClick } = props;

  return (
    <div className={cn('flex items-center gap-1 w-full', className, onClick ? 'cursor-pointer' : '')} onClick={onClick}>
      {/* 左侧绿色竖线装饰 */}
      <div className="w-[2px] h-[18px] bg-[#37E4A6] shrink-0" />
      {/* 文本内容 */}
      <span className="text-[12px] font-normal leading-[1.5] tracking-[0.015em] text-[#525252] truncate">{text}</span>
    </div>
  );
};
